module.exports = __webpack_public_path__ + "img/9839a8e.png";